// extracted by mini-css-extract-plugin
export var outer = "style-module--outer--Skhym";
export var item = "style-module--item--1UCb1";
export var itemInner = "style-module--itemInner--nso-r";
export var itemInnerExternal = "style-module--itemInnerExternal--2g4zk";
export var itemInnerTitle = "style-module--itemInnerTitle--3nWTp";
export var itemInnerActive = "style-module--itemInnerActive--3c8gf";